module.exports = __webpack_public_path__ + "assets/img/DB-Results-2-Service-Page-w960.1976d97f.webp";